import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { SystemPlatformListingItem } from "../SystemPlatformListingItem";
import { SystemPlatformListingFilters } from "../useSystemPlatformListingFilters";

interface ISystemPlatformListingContext {
    systemPlatforms: SystemPlatformListingItem[];
    airlineName: string;
    buzzId?: string;
    shreqId?: string;
    isLoading: boolean;
    totalItems: number;
    load(filters: SystemPlatformListingFilters): void;
    createSystemPlatform(systemPlatform: SystemPlatformListingItem): void;
    deleteSystemPlatform(systemPlatformId: string): void;
}

export const SystemPlatformListingContext = createContext<ISystemPlatformListingContext>({
    systemPlatforms: [],
    airlineName: "",
    buzzId: undefined,
    shreqId: undefined,
    isLoading: false,
    totalItems: 0,
    load: contextFunctionInit,
    createSystemPlatform: contextFunctionInit,
    deleteSystemPlatform: contextFunctionInit
});
